var card_styles = {
  card: {
    display: "flex",
    flexDirection: "column" as const,
    alignSelf: "stretch",
    border: "1px solid var(--Gray---100, #E8E9EB)",
    background: "var(--Gray---25, #FBFBFB)",
    boxShadow: "none",
    borderRadius: "4px",
    width: "100%",
  },
  top: {
    display: "flex",
    justifyContent: "space-between", // ✅ Key!
    alignItems: "center",
    gap: "8px",
    width: "100%", // ✅ ensure full width
  },
  name_container: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: "1 0 0",
  },
  name: {
    flex: "1 0 0",
    color: "var(--Black---1000, #191924)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  },
  next_payment_on_date: {
    display: "flex",
    width: "100%",
    maxWidth: "600px",
    height: "24px",
    padding: "6px 0px 0px 0px",
    alignItems: "baseline",
    gap: "4px",
  },
  label_1: {
    color: "var(--Gray---800, #4F5467)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
  text_1: {
    color: "var(--Black---1000, #191924)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
  },
  label_2: {
    color: "var(--Gray---800, #4F5467)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
  text_2: {
    color: "var(--Black---1000, #191924)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
  },
  status: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "8px",
  },
  status_label: {
    color: "var(--Gray---800, #4F5467)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
  status_tile_active: {
    display: "flex",
    padding: "6px 8px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: "4px",
    background: "var(--Green---100, #7AA303)",
  },
  status_tile_active_past_due: {
    display: "flex",
    padding: "6px 8px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: "4px",
    background: "var(--Events-Type-Note-100, #EFAC00)",
  },
  status_tile_cancelled: {
    display: "flex",
    padding: "6px 8px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: "4px",
    background: "var(--Gray---600, #9094A0)",
  },
  status_tile_text: {
    color: "var(--White, #FFF)",
    textAlign: "center" as const,
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px",
  },
  details_container: {
    display: "flex",
    flexDirection: "column" as const,
    padding: "0px 48px 16px 48px",
    gap: "48px",
    alignSelf: "stretch",
  },
  details_row_1: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "flex-start",
    gap: "2px",
    flex: "1 0 0",
  },
  cancellation_label: {
    width: "130px",
    color: "var(--Gray---800, #4F5467)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    margin: 0,
  },
  cancellation_text: {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical" as const,
    WebkitLineClamp: "2",
    flex: "1 0 0",
    overflow: "hidden",
    color: "var(--Black---1000, #191924)",
    textOverflow: "ellipsis",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    margin: 0,
  },
  label_and_text_row: {
    display: "flex" as const,
    flexDirection: "row" as const,
    gap: "20px",
  },
  cancel_button: {
    display: "flex",
    height: "40px",
    padding: "8px 16px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "4px",
    border: "1px solid var(--Red---200, #DC5020)",
    color: "var(--Red---200, #DC5020)",
    background: "inherit",
    marginTop: "0 auto",
    alignSelf: "flex-end",
  },
  cancel_button_disabled: {
    display: "flex",
    height: "40px",
    padding: "8px 16px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "4px",
    border: "1px solid var(--Gray---100, #E8E9EB)",
    color: "var(--Gray---600, #9094A0)",
    background: "inherit",
    marginTop: "0 auto",
    alignSelf: "flex-end",
  },
  warning_icon_container: {
    display: "flex",
    width: "24px",
    height: "24px",
    padding: "2.5px 2px 3.5px 2px",
    justifyContent: "center",
    alignItems: "center",
  },
  accordion: {
    display: "flex",
    flexDirection: "column" as const,
    alignSelf: "stretch",
    border: "1px solid #E8E9EB",
    background: "#FBFBFB",
    boxShadow: "none",
    borderRadius: "4px",
    width: "100%",
  },
  accordion_summary: { padding: 0 },
  contents: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px",
    gap: "8px",
    width: "100%",
    fontFamily: "Montserrat",
  },
  left_col: { display: "flex", alignItems: "center", gap: "8px" },
  left_col_icon: { color: "#ffc107" },
  left_col_text: {
    fontWeight: "bold",
    fontSize: "18px",
    color: "#191924",
  },
  right_col: { display: "flex", alignItems: "center", gap: "24px" },
  status_v2: {
    color: "#fff",
    padding: "4px 12px",
    borderRadius: "6px",
    fontWeight: "bold",
  },
  next_pay: { color: "#555", fontSize: "14px" },
  next_pay_caption: {},
  frozen: {
    width: "15px",
    height: "15px",
    borderRadius: "50%",
    backgroundColor: "#4a75c3",
    color: "white",
    fontWeight: "bold",
    fontFamily: "sans-serif",
    display: "flex",
    alignItems: "center",
    // justifyContent: "center",
    fontSize: "12px",
    paddingTop: "1px",
  },
};

var accordion_styles = (expanded: any) => {
  return {
    "&:before": { display: "none" },
    fontFamily: "Montserrat",
    width: "100%",
    padding: 0,
    border: "1px solid #E8E9EB",
    borderTop: "none",
    "&:first-of-type": {
      borderTop: "1px solid #E8E9EB",
      borderTopLeftRadius: "4px",
      borderTopRightRadius: "4px",
    },
    "&:last-of-type": {
      borderBottomLeftRadius: "4px",
      borderBottomRightRadius: "4px",
    },
    "&::before": {
      display: "none", // ✅ disables the default MUI divider
    },
  };
};

export { accordion_styles };

export default card_styles;